// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"install-mobile"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M14 2H5V22H19V12M12 18H12.0039V18.0039H12V18Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M16.498 5.49942L19.0006 8.00196L21.5012 5.50127M19.0006 7.25V2.00195","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const InstallMobileIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'install-mobile',
    ref,
    icon: element,
  },
));

InstallMobileIcon.displayName = 'InstallMobileIcon';

export default InstallMobileIcon;
